import { useFeatureValue } from '@shared/core/featureFlags';
import { CASH_FUNDS_PUBLIC_URL_PATH } from '../Catalog.constants';

export const useActiveCashFundPartnerShop = (): string | null => {
  const { value: active } = useFeatureValue('activeCashFundPartner');
  const { value: shop } = useFeatureValue('enableCashFundPartnerShop');
  if (!active || !shop || active !== shop) return null;
  return shop;
};

export const useIsAllyShopPromo = (publicUrlPath: string | undefined): boolean => {
  const partner = useActiveCashFundPartnerShop();
  return partner === 'ally' && publicUrlPath === CASH_FUNDS_PUBLIC_URL_PATH;
};
